// DigitalMarketing.js
import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function DigitalMarketing() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        * {
          box-sizing: border-box;
        }
        body, #root {
          overflow-x: hidden;
          max-width: 100vw;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 sm:py-32 overflow-hidden">
        {/* Background Image using img tag */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_85.png" 
            alt="Digital Marketing Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="max-w-7xl mx-auto relative z-10 w-full">

          {/* Main Heading */}
          <h1 className="text-2xl sm:text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-8 leading-tight max-w-6xl">
            Digital Marketing: Mastering Online Strategies for Business Growth
          </h1>

          {/* Description */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-4xl mb-12">
            Navigate the rapidly evolving digital landscape with cutting-edge strategies that drive measurable results. Discover how AI, personalization, and integrated campaigns transform customer engagement and accelerate business growth in today's competitive marketplace.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button className="px-8 py-3 bg-orange-500 text-white rounded-md font-medium hover:bg-orange-600 transition">
              Build Your Strategy
            </button>
            <button className="px-8 py-3 border border-orange-500 text-orange-500 rounded-md font-medium hover:bg-orange-500 hover:text-white transition">
              Explore Insights
            </button>
          </div>

        </div>
      </section>

        <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
            
            <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_111.png" 
                    alt="Digital Marketing Team" 
                    className="w-full h-full object-cover"
                />
                </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
                
                {/* Main Heading */}
                <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8">
                Why Digital Marketing is Your Business's Greatest Asset Today
                </h2>

                {/* Cards Grid */}
                <div className="grid gap-6">
                
                {/* First Row - Two Cards */}
                <div className="grid md:grid-cols-2 gap-6">
                    
                    {/* Global Reach Card */}
                    <div className="border-2 border-orange-500 rounded-2xl p-6 space-y-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h3 className="text-xl font-bold text-white">
                        Global Reach, Targeted Impact
                    </h3>
                    <p className="text-gray-300 text-sm leading-relaxed">
                        Connect with billions worldwide through cost-effective campaigns that precisely target your ideal customers, maximizing every marketing dollar spent.
                    </p>
                    </div>

                    {/* Real-Time Intelligence Card */}
                    <div className="border-2 border-orange-500 rounded-2xl p-6 space-y-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                    </div>
                    <h3 className="text-xl font-bold text-white">
                        Real-Time Intelligence
                    </h3>
                    <p className="text-gray-300 text-sm leading-relaxed">
                        Harness powerful analytics that deliver instant insights, empowering data-driven decisions and driving significantly higher return on investment.
                    </p>
                    </div>

                </div>

                {/* Second Row - Full Width Card */}
                <div className="border-2 border-orange-500 rounded-2xl p-6 space-y-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    </div>
                    <h3 className="text-xl font-bold text-white">
                    Lasting Relationships
                    </h3>
                    <p className="text-gray-300 text-sm leading-relaxed">
                    Build meaningful customer connections through personalized engagement that transforms one-time buyers into loyal brand advocates.
                    </p>
                </div>

                </div>

            </div>

            </div>

        </div>
        </section>

        {/* Section 2: Chapter 1 */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
            
            {/* Content Card */}
            <div className="bg-black/60 rounded-3xl p-6 sm:p-12 lg:p-16">

            {/* Main Heading */}
            <h3 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-8">
                The Digital Marketing Landscape 
            </h3>

            {/* Description */}
            <p className="text-gray-300 text-lg lg:text-xl leading-relaxed">
                The digital marketing ecosystem has transformed dramatically, powered by artificial intelligence, advanced personalization, and seamless omnichannel experiences. Understanding this new landscape is essential for businesses seeking sustainable competitive advantage and meaningful customer connections in an increasingly digital-first world.
            </p>

            </div>

        </div>
        </section>

        {/* Section 3: AI Revolution */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
            
            <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-8">
                
                {/* Main Heading */}
                <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8">
                The AI Revolution: Your New Marketing Powerhouse
                </h2>

                {/* Feature 01 - Generative AI Integration */}
                <div className="space-y-4">
                <div className="flex items-center gap-4">
                    <span className="text-orange-500 font-bold text-lg">01</span>
                    <div className="h-px bg-orange-500 flex-1"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">
                    Generative AI Integration
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    By 2024, generative AI became embedded in nearly all marketing software platforms, revolutionizing content creation and campaign optimization.
                </p>
                </div>

                {/* Feature 02 - AI Agents as Simplifiers */}
                <div className="space-y-4">
                <div className="flex items-center gap-4">
                    <span className="text-orange-500 font-bold text-lg">02</span>
                    <div className="h-px bg-orange-500 flex-1"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">
                    AI Agents as Simplifiers
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    Intelligent AI agents now serve as "Chief Simplifier Officers," autonomously managing complex data workflows and freeing marketers for strategic thinking.
                </p>
                </div>

                {/* Feature 03 - Enhanced Customer Experience */}
                <div className="space-y-4">
                <div className="flex items-center gap-4">
                    <span className="text-orange-500 font-bold text-lg">03</span>
                    <div className="h-px bg-orange-500 flex-1"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">
                    Enhanced Customer Experience
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    Leading brands like Kingfisher deploy AI-powered recommendation engines that seamlessly process voice, text, and video inputs for superior personalization.
                </p>
                </div>

            </div>

            {/* Right Side - Image and Bottom Text */}
            <div className="space-y-6">
                
                {/* AI Robot Image */}
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_112.png" 
                    alt="AI Marketing Robot" 
                    className="w-full h-full object-cover"
                />
                </div>

                {/* Bottom Description */}
                <p className="text-gray-300 text-xl leading-relaxed">
                AI doesn't replace marketers—it amplifies their capabilities, enabling unprecedented levels of personalization, efficiency, and customer insight at scale.
                </p>

            </div>

            </div>

        </div>
        </section>

        {/* Section 4: Personalization */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        <div className="max-w-7xl mx-auto">
            
            <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_113.png" 
                    alt="Personalization Dashboard" 
                    className="w-full h-[550px] object-cover"
                />
                </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
                
                {/* Main Heading */}
                <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8">
                Personalization is King: Why 80% of Consumers Expect It
                </h2>

                {/* Stats Grid */}
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                
                {/* Stat 1 - Revenue Uplift */}
                <div className="space-y-3">
                    <h3 className="text-3xl sm:text-5xl font-bold text-white">20%+</h3>
                    <h4 className="text-xl font-bold text-white">Revenue Uplift</h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                    Brands delivering truly personalized content experiences see revenue increases exceeding 20% compared to generic approaches.
                    </p>
                </div>

                {/* Stat 2 - AI Investment */}
                <div className="space-y-3">
                    <h3 className="text-3xl sm:text-5xl font-bold text-white">56%</h3>
                    <h4 className="text-xl font-bold text-white">AI Investment</h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                    Over half of marketing leaders actively invest in AI-driven personalization tools to meet rising consumer expectations.
                    </p>
                </div>

                {/* Stat 3 - Consumer Demand */}
                <div className="space-y-3">
                    <h3 className="text-3xl sm:text-5xl font-bold text-white">80%</h3>
                    <h4 className="text-xl font-bold text-white">Consumer Demand</h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                    Four out of five consumers now expect personalized experiences across every touchpoint with brands they engage.
                    </p>
                </div>

                </div>

                {/* Bottom Description */}
                <div className="space-y-4">
                <p className="text-gray-300 text-base leading-relaxed">
                    Omnichannel experiences seamlessly connect customers across platforms, creating cohesive journeys that build trust and drive loyalty. Modern consumers demand consistency whether they're browsing on mobile, desktop, or in-store.
                </p>
                </div>

            </div>

            </div>

        </div>
        </section>

        <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">

            {/* Top Heading */}
                <h3 className="text-2xl lg:text-3xl font-bold text-white mb-8">
                Data + AI = Marketing Mastery
                </h3>

                {/* Description Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                The convergence of big data analytics and artificial intelligence creates unprecedented opportunities for marketers to understand, predict, and influence customer behavior with remarkable precision and effectiveness.
                </p>
            
            <div className="grid lg:grid-cols-2 gap-12 items-center py-20">

            {/* Left Side - Content */}
            <div className="space-y-8">

                {/* Main Heading */}
                <h3 className="text-xl sm:text-3xl lg:text-4xl font-bold text-orange-500 mb-6">
                Core Digital Marketing Strategies Explained
                </h3>

                {/* Bottom Description */}
                <p className="text-gray-300 text-lg leading-relaxed">
                Success in digital marketing requires mastery of fundamental strategies that work synergistically to amplify your brand's reach, engagement, and conversion rates. Each channel offers unique advantages that, when orchestrated effectively, create a powerful marketing ecosystem driving sustainable business growth.
                </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_114.png" 
                    alt="Digital Marketing Strategy" 
                    className="w-full h-[350px] object-cover"
                />
                </div>
            </div>

            </div>

        </div>
        </section>

        {/* Section 6: SEO */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-12">
            Search Engine Optimization (SEO): Be Found When It Matters Most
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_115.png" 
                    alt="SEO Dashboard" 
                    className="w-full h-[450px] object-cover"
                />
                </div>
            </div>

            {/* Right Side - Features */}
            <div className="space-y-6">
                
                {/* Feature 1 - AI-Enhanced Research */}
                <div className="flex gap-4">
                <div className="w-12 h-12 bg-orange-300 rounded-xl flex-shrink-0"></div>
                <div className="space-y-2">
                    <h3 className="text-2xl font-bold text-black">
                    AI-Enhanced Research
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    SEO leverages artificial intelligence for sophisticated keyword research and voice search optimization, anticipating user intent with unprecedented accuracy.
                    </p>
                </div>
                </div>

                {/* Feature 2 - Revolutionary Discovery */}
                <div className="flex gap-4">
                <div className="w-12 h-12 bg-orange-300 rounded-xl flex-shrink-0"></div>
                <div className="space-y-2">
                    <h3 className="text-2xl font-bold text-black">
                    Revolutionary Discovery
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Google's AI-powered features like "Circle to Search" fundamentally redefine how users discover content, requiring adaptive optimization strategies.
                    </p>
                </div>
                </div>

                {/* Feature 3 - Quality Remains King */}
                <div className="flex gap-4">
                <div className="w-12 h-12 bg-orange-300 rounded-xl flex-shrink-0"></div>
                <div className="space-y-2">
                    <h3 className="text-2xl font-bold text-black">
                    Quality Remains King
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Despite technological advances, exceptional content quality and superior user experience continue dominating as primary ranking factors.
                    </p>
                </div>
                </div>

            </div>

            </div>

        </div>
        </section>
        
        {/* Section 7: PPC */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-4xl lg:text-4xl font-bold text-white mb-12">
            Pay-Per-Click (PPC): Precision Targeting for Immediate Impact
            </h2>

            {/* Three Cards Grid */}
            <div className="grid md:grid-cols-3 gap-6">
            
            {/* Card 1 - Smart Bidding Strategies */}
            <div className="border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                Smart Bidding Strategies
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                Machine learning algorithms continuously optimize bidding strategies in real-time, maximizing advertising spend efficiency and reducing wasted budget across campaigns.
                </p>
            </div>

            {/* Card 2 - Dynamic Creative Optimization */}
            <div className="border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                Dynamic Creative Optimization
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                Integration of PPC with DCO technology automatically tests and serves the highest-performing ad variations, significantly boosting conversion rates and campaign effectiveness.
                </p>
            </div>

            {/* Card 3 - True ROI Measurement */}
            <div className="border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                True ROI Measurement
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                Advanced cross-channel attribution tools provide comprehensive insights into true campaign ROI, revealing the complete customer journey across multiple touchpoints.
                </p>
            </div>

            </div>

        </div>
        </section>
        
        {/* Section 8: Social Media Marketing */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20 ">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-16 text-center">
            Social Media Marketing: Building Communities and Driving Engagement
            </h2>

            <div className="grid lg:grid-cols-2 gap-16 items-start mb-16">
            
            {/* Left Side - Content Strategy Breakdown */}
            <div className="space-y-12">
                
                {/* 70% Educational */}
                <div className="flex gap-6 items-start">
                <div className="flex-shrink-0">
                    <div className="w-20 h-20 rounded-full border-4 border-orange-500 flex items-center justify-center">
                    <span className="text-2xl font-bold text-orange-500">70%</span>
                    </div>
                </div>
                <div className="space-y-2 pt-2">
                    <h3 className="text-2xl font-bold text-white">
                    Educational
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Value-driven content that educates, informs, and empowers your audience builds authority and trust.
                    </p>
                </div>
                </div>

                {/* 20% Curated */}
                <div className="flex gap-6 items-start">
                <div className="flex-shrink-0">
                    <div className="w-20 h-20 rounded-full border-4 border-orange-500 flex items-center justify-center">
                    <span className="text-2xl font-bold text-orange-500">20%</span>
                    </div>
                </div>
                <div className="space-y-2 pt-2">
                    <h3 className="text-2xl font-bold text-white">
                    Curated
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Thoughtfully selected third-party content positions your brand as a knowledgeable industry resource.
                    </p>
                </div>
                </div>

                {/* 10% Promotional */}
                <div className="flex gap-6 items-start">
                <div className="flex-shrink-0">
                    <div className="w-20 h-20 rounded-full border-4 border-orange-500 flex items-center justify-center">
                    <span className="text-2xl font-bold text-orange-500">10%</span>
                    </div>
                </div>
                <div className="space-y-2 pt-2">
                    <h3 className="text-2xl font-bold text-white">
                    Promotional
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Strategic promotional content converts engaged followers without overwhelming your community.
                    </p>
                </div>
                </div>

            </div>

            {/* Right Side - Visual Representation */}
            <div className="space-y-8">
                
                {/* Pie Chart Visualization */}
                <div className="relative aspect-square max-w-md mx-auto">
                {/* SVG Pie Chart */}
                <svg viewBox="0 0 200 200" className="w-full h-full transform -rotate-90">
                    {/* 70% Educational - Large segment */}
                    <circle
                    cx="100"
                    cy="100"
                    r="80"
                    fill="none"
                    stroke="#ffc400ff"
                    strokeWidth="40"
                    strokeDasharray="352 528"
                    strokeDashoffset="0"
                    />
                    {/* 20% Curated */}
                    <circle
                    cx="100"
                    cy="100"
                    r="80"
                    fill="none"
                    stroke="#ffffffff"
                    strokeWidth="40"
                    strokeDasharray="105.6 528"
                    strokeDashoffset="-352"
                    />
                    {/* 10% Promotional */}
                    <circle
                    cx="100"
                    cy="100"
                    r="80"
                    fill="none"
                    stroke="#ff0000ff"
                    strokeWidth="40"
                    strokeDasharray="52.8 528"
                    strokeDashoffset="-457.6"
                    />
                    {/* Center circle */}
                    <circle cx="100" cy="100" r="50" fill="#000000" />
                </svg>
                
                {/* Center Icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <svg className="w-16 h-16 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                </div>
                </div>

                {/* Legend */}
                <div className="flex flex-wrap justify-center gap-4 sm:gap-8">
                <div className="flex items-center gap-2">
                    <div className="w-4 h-4 rounded-full bg-yellow-500"></div>
                    <span className="text-white text-sm">70% Educational</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="w-4 h-4 rounded-full bg-white"></div>
                    <span className="text-white text-sm">20% Curated</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="w-4 h-4 rounded-full bg-red-500"></div>
                    <span className="text-white text-sm">10% Promotional</span>
                </div>
                </div>

            </div>

            </div>

            {/* Bottom Section - Image and Description */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image */}
            <div className="relative rounded-3xl overflow-hidden">
                <img 
                src="/Assests/home_page_116.png" 
                alt="Social Media Engagement" 
                className="w-full h-[400px] object-cover"
                />
            </div>

            {/* Right - Description */}
            <div className="space-y-6">
                <p className="text-gray-300 text-lg leading-relaxed">
                Platforms like TikTok and Instagram continuously evolve with AI-driven content recommendation engines that amplify reach. Virtual events and immersive metaverse experiences expand brand presence, creating deeper emotional connections and fostering unprecedented levels of customer loyalty.
                </p>
            </div>

            </div>

        </div>
        </section>

        {/* Section 9: Email Marketing - New Design */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-8 ">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-16 text-center">
            Email Marketing: Personalized Journeys That Convert
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_117.png" 
                    alt="Email Marketing Campaign" 
                    className="w-full h-full object-cover"
                />
                </div>
            </div>

            {/* Right Side - Three Features */}
            <div className="space-y-8">
                
                {/* Feature 1 - AI Segmentation */}
                <div className="bg-neutral-900 border-2 border-orange-500 rounded-2xl p-6 space-y-4 hover:bg-neutral-800 transition-colors">
                <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                    </div>
                    <div>
                    <h3 className="text-2xl font-bold text-white mb-3">
                        AI Segmentation
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                        Predictive analytics and machine learning enable hyper-targeted message delivery based on individual customer behaviors and preferences.
                    </p>
                    </div>
                </div>
                </div>

                {/* Feature 2 - Interactive Content */}
                <div className="bg-neutral-900 border-2 border-orange-500 rounded-2xl p-6 space-y-4 hover:bg-neutral-800 transition-colors">
                <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                    </div>
                    <div>
                    <h3 className="text-2xl font-bold text-white mb-3">
                        Interactive Content
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                        Embedded video, dynamic product recommendations, and interactive elements dramatically increase engagement and click-through rates.
                    </p>
                    </div>
                </div>
                </div>

                {/* Feature 3 - Journey Automation */}
                <div className="bg-neutral-900 border-2 border-orange-500 rounded-2xl p-6 space-y-4 hover:bg-neutral-800 transition-colors">
                <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    </div>
                    <div>
                    <h3 className="text-2xl font-bold text-white mb-3">
                        Journey Automation
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                        Sophisticated automation sequences nurture leads through every stage of the buyer's journey with timely, relevant messaging.
                    </p>
                    </div>
                </div>
                </div>

            </div>

            </div>

        </div>
        </section>

        {/* Section 10: Advanced Tactics and Tools */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-8">
            Advanced Tactics and Tools
            </h2>

            {/* Description */}
            <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-5xl">
            Staying ahead requires embracing sophisticated technologies and methodologies that integrate seamlessly across your marketing stack. These advanced approaches enable more precise targeting, accurate measurement, and optimal resource allocation for maximum business impact.
            </p>

        </div>
        </section>

        {/* Section 11: Martech and Adtech Convergence */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
            
            {/* Content Card */}
            <div className="bg-black/80 rounded-3xl p-6 sm:p-12 lg:p-16">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
                Martech and Adtech Convergence: Simplifying Complex Campaigns
            </h2>

            {/* The Integration Imperative */}
                <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-white">
                    The Integration Imperative
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    With over 14,000 marketing technology tools available, strategic integration prevents fragmentation and ensures cohesive campaign execution. Unified platforms seamlessly connect paid and owned media channels, maintaining consistent messaging across every customer touchpoint.
                    </p>
                </div>

            <div className="grid lg:grid-cols-2 gap-12 items-start mt-20">
                
                {/* Left Side - Content */}
                <div className="space-y-8">

                {/* Image */}
                <div className="relative rounded-3xl overflow-hidden">
                    <img 
                    src="/Assests/home_page_118.png" 
                    alt="Martech Integration" 
                    className="w-full h-[480px] object-cover"
                    />
                </div>

                </div>

                {/* Right Side - Three Cards */}
                <div className="space-y-6 mt-10 lg:mt-38">
                
                {/* Card 1 - Unified Platforms */}
                <div className="bg-black border-2 border-orange-500 rounded-2xl p-6 space-y-3">
                    <h4 className="text-xl font-bold text-white">
                    Unified Platforms
                    </h4>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Connect disparate marketing tools into cohesive ecosystems that share data and insights seamlessly.
                    </p>
                </div>

                {/* Card 2 - Customer Data Platforms */}
                <div className="bg-black border-2 border-orange-500 rounded-2xl p-6 space-y-3">
                    <h4 className="text-xl font-bold text-white">
                    Customer Data Platforms
                    </h4>
                    <p className="text-gray-300 text-base leading-relaxed">
                    CDPs consolidate customer information from multiple sources, enabling sophisticated personalization at scale.
                    </p>
                </div>

                {/* Card 3 - Consistent Messaging */}
                <div className="bg-black border-2 border-orange-500 rounded-2xl p-6 space-y-3">
                    <h4 className="text-xl font-bold text-white">
                    Consistent Messaging
                    </h4>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Integrated systems ensure brand voice and customer experience remain uniform across all channels.
                    </p>
                </div>

                </div>

            </div>

            </div>

        </div>
        </section>

        {/* Section 12: Marketing Mix Modeling */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-16 sm:py-32 overflow-hidden min-h-screen flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
            <img 
            src="/Assests/home_page_42.png" 
            alt="MMM Analytics Background" 
            className="w-full h-full object-cover"
            />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="max-w-7xl mx-auto relative z-10 w-full">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-16 text-center">
            Marketing Mix Modeling (MMM): Smarter Measurement for Smarter Spending
            </h2>

            {/* Top Two Features */}
            <div className="grid md:grid-cols-2 gap-12 mb-16">
            
            {/* Integration Testing */}
            <div className="text-center space-y-4">
                <h3 className="text-2xl font-bold text-white">
                Integration Testing
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed">
                Modern MMMs merge with incrementality testing and multi-touch attribution for granular, actionable performance insights.
                </p>
            </div>

            {/* Budget Optimization */}
            <div className="text-center space-y-4">
                <h3 className="text-2xl font-bold text-white">
                Budget Optimization
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed">
                Continuous optimization unlocks full marketing potential, particularly critical when operating with constrained budgets.
                </p>
            </div>

            </div>

            {/* Timeline with 3 Points */}
            <div className="relative mb-16">
            
            {/* Horizontal Line */}
            <div className="absolute top-6 left-0 right-0 h-0.5 bg-orange-500"></div>

            <div className="grid md:grid-cols-3 gap-8 relative">
                
                {/* Point 1 */}
                <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-xl mb-4 relative z-10 border-4 border-black">
                    1
                </div>
                </div>

                {/* Point 2 */}
                <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-xl mb-4 relative z-10 border-4 border-black">
                    2
                </div>
                <div className="text-center space-y-3">
                    <h3 className="text-2xl font-bold text-white">
                    Real-Time Analytics
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                    Tools like Google's Meridian MMM deliver real-time, cross-channel performance data enabling rapid optimization decisions.
                    </p>
                </div>
                </div>

                {/* Point 3 */}
                <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-xl mb-4 relative z-10 border-4 border-black">
                    3
                </div>
                </div>

            </div>

            </div>

            {/* Bottom Description */}
            <div className="text-center max-w-5xl mx-auto">
            <p className="text-gray-300 text-lg leading-relaxed">
                Advanced measurement frameworks help marketers understand the true incremental impact of each marketing dollar spent, moving beyond last-click attribution to reveal the complex interplay between channels that drive conversions.
            </p>
            </div>

        </div>
        </section>

        {/* Section 13: Balancing Brand and Performance Marketing */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
            Balancing Brand and Performance Marketing: The New Imperative
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-start">
            
            {/* Left Side - Image */}
            <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                <img 
                    src="/Assests/home_page_119.png" 
                    alt="Brand and Performance Balance" 
                    className="w-full h-[400px] object-cover"
                />
                </div>
            </div>

            {/* Right Side - Three Cards in Grid */}
            <div className="grid gap-6">
                
                {/* First Row - Two Cards */}
                <div className="grid md:grid-cols-2 gap-6">
                
                {/* Card 1 - Strategic Alignment */}
                <div className="bg-orange-300 rounded-2xl p-6 space-y-3 relative">
                    <div className="absolute -top-4 left-6 w-10 h-10 bg-orange-400 rounded-full flex items-center justify-center text-black font-bold text-lg">
                    1
                    </div>
                    <h3 className="text-xl font-bold text-black pt-4">
                    Strategic Alignment
                    </h3>
                    <p className="text-black text-sm leading-relaxed">
                    High-performing agencies expertly align long-term brand building initiatives with short-term ROI goals for sustainable growth.
                    </p>
                </div>

                {/* Card 2 - Connected Strategies */}
                <div className="bg-orange-300 rounded-2xl p-6 space-y-3 relative">
                    <div className="absolute -top-4 left-6 w-10 h-10 bg-orange-400 rounded-full flex items-center justify-center text-black font-bold text-lg">
                    2
                    </div>
                    <h3 className="text-xl font-bold text-black pt-4">
                    Connected Strategies
                    </h3>
                    <p className="text-black text-sm leading-relaxed">
                    Leverage unified data and messaging across the entire marketing funnel, from awareness to conversion and retention.
                    </p>
                </div>

                </div>

                {/* Second Row - Full Width Card */}
                <div className="bg-orange-300 rounded-2xl p-6 space-y-3 relative">
                <div className="absolute -top-4 left-6 w-10 h-10 bg-orange-400 rounded-full flex items-center justify-center text-black font-bold text-lg">
                    3
                </div>
                <h3 className="text-xl font-bold text-black pt-4">
                    AI-Driven Creativity
                </h3>
                <p className="text-black text-sm leading-relaxed">
                    Dynamic creative optimization powered by AI simultaneously boosts brand awareness and conversion rates through intelligent personalization.
                </p>
                </div>

            </div>

            </div>

            {/* Bottom Description */}
            <div className="mt-12 max-w-5xl">
            <p className="text-white text-lg leading-relaxed">
                The most successful brands recognize that performance marketing and brand building aren't opposing forces—they're complementary strategies that reinforce each other when executed thoughtfully.
            </p>
            </div>

        </div>
        </section>

        {/* Section 14: Building Strategy - Header */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-12 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-8">
            Building Your Digital Marketing Strategy
            </h2>

            {/* Description */}
            <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-5xl">
            Creating an effective digital marketing strategy requires systematic planning, clear objectives, and thoughtful channel selection. Follow these proven steps to develop a comprehensive approach that aligns with your business goals and resonates with your target audience.
            </p>

        </div>
        </section>

    {/* Section 14: Step 1 - Market Research */}
    <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
    <div className="max-w-7xl mx-auto">
        
        {/* Step Heading */}
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
        Step 1: Conduct Deep Market Research and Audience Segmentation
        </h2>

        {/* Three Columns */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
        
        {/* Column 1 - Customer Surveys */}
        <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white">
            Customer Surveys
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
            Deploy comprehensive surveys to capture direct customer feedback, preferences, and pain points that inform strategic decisions.
            </p>
        </div>

        {/* Column 2 - Social Listening */}
        <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white">
            Social Listening
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
            Monitor conversations across social platforms to understand sentiment, emerging trends, and unmet customer needs in real-time.
            </p>
        </div>

        {/* Column 3 - AI Analytics */}
        <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white">
            AI Analytics
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
            Harness artificial intelligence to uncover hidden patterns in customer data and predict future behaviors with remarkable accuracy.
            </p>
        </div>

        </div>

        {/* Bottom Description */}
        <div className="max-w-5xl">
        <p className="text-gray-300 text-lg leading-relaxed">
            Develop detailed buyer personas that go beyond demographics to include psychographics, behaviors, motivations, and challenges. These personas guide messaging, channel selection, and content creation for maximum relevance and impact.
        </p>
        </div>

    </div>
    </section>

    {/* Section 15: Step 2 - SMART Goals */}
    <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-black">
    <div className="max-w-7xl mx-auto">
        
        {/* Main Heading */}
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
        Step 2: Set SMART Goals and KPIs Aligned with Business Objectives
        </h2>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
        
        {/* Left Side - Content */}
        <div className="space-y-8">
            
            {/* Define Success Metrics */}
            <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white">
                Define Success Metrics
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
                Establish Specific, Measurable, Achievable, Relevant, and Time-bound goals that directly support your broader business objectives. Clear KPIs enable performance tracking and data-driven optimization throughout your campaigns.
            </p>
            </div>

            {/* Traffic Goals */}
            <div className="space-y-3">
            <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                <h4 className="text-xl font-bold text-white">
                Traffic Goals
                </h4>
            </div>
            <p className="text-gray-300 text-base leading-relaxed pl-6">
                Increase organic website traffic by 25% within six months through enhanced SEO and content marketing.
            </p>
            </div>

            {/* Engagement Metrics */}
            <div className="space-y-3">
            <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                <h4 className="text-xl font-bold text-white">
                Engagement Metrics
                </h4>
            </div>
            <p className="text-gray-300 text-base leading-relaxed pl-6">
                Boost email open rates by 15% and click-through rates by 10% through personalization and optimization.
            </p>
            </div>

            {/* Conversion Targets */}
            <div className="space-y-3">
            <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                <h4 className="text-xl font-bold text-white">
                Conversion Targets
                </h4>
            </div>
            <p className="text-gray-300 text-base leading-relaxed pl-6">
                Improve landing page conversion rates by 20% through A/B testing and user experience enhancements.
            </p>
            </div>

        </div>

        {/* Right Side - Image and Description */}
        <div className="space-y-6">
            
            {/* Dashboard Image */}
            <div className="relative rounded-3xl overflow-hidden">
            <img 
                src="/Assests/home_page_120.png" 
                alt="KPI Dashboard" 
                className="w-full h-[400px] object-cover"
            />
            </div>

            {/* Description */}
            <p className="text-gray-300 text-base leading-relaxed">
            Implement comprehensive dashboards that visualize progress toward goals in real-time, enabling quick pivots when performance deviates from targets and ensuring accountability across teams.
            </p>

        </div>

        </div>

    </div>
    </section>

    {/* Section 16: Step 3 - Channel Mix */}
    <section className="relative px-4 sm:px-8 lg:px-24 py-8 overflow-hidden flex items-center">
    {/* Background Image */}
    <div className="absolute inset-0 overflow-hidden">
        <img 
        src="/Assests/home_page_25.png" 
        alt="Channel Strategy Background" 
        className="w-full h-full object-cover"
        />
    </div>
    
    {/* Dark overlay */}
    <div className="absolute inset-0 bg-black/70"></div>

    <div className="max-w-7xl mx-auto relative z-10 w-full">
        
        {/* Main Heading */}
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
        Step 3: Choose the Right Mix of Channels and Tactics
        </h2>

        {/* Channel Grid */}
        <div className="border-2 border-orange-500 rounded-2xl overflow-hidden mb-8">
        
        {/* First Row */}
        <div className="grid md:grid-cols-2 border-b-2 border-orange-500">
            
            {/* SEO Foundation */}
            <div className="p-4 sm:p-8 border-r-2 border-orange-500 bg-black/40">
            <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                </div>
                <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                    SEO Foundation
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    Build organic visibility and long-term traffic growth
                </p>
                </div>
            </div>
            </div>

            {/* PPC Acceleration */}
            <div className="p-4 sm:p-8 bg-black/40">
            <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                </div>
                <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                    PPC Acceleration
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    Drive immediate traffic and test messaging quickly
                </p>
                </div>
            </div>
            </div>

        </div>

        {/* Second Row */}
        <div className="grid md:grid-cols-2">
            
            {/* Social Engagement */}
            <div className="p-4 sm:p-8 border-r-2 border-orange-500 bg-black/40">
            <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                </div>
                <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                    Social Engagement
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    Build community and amplify brand awareness
                </p>
                </div>
            </div>
            </div>

            {/* Email Nurturing */}
            <div className="p-4 sm:p-8 bg-black/40">
            <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                </div>
                <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                    Email Nurturing
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                    Convert prospects and retain loyal customers
                </p>
                </div>
            </div>
            </div>

        </div>

        </div>

        {/* Bottom Description */}
        <div className="max-w-5xl">
        <p className="text-gray-300 text-lg leading-relaxed">
            Prioritize channels based on where your target audience spends time, their preferred content formats, and your budget constraints. An integrated approach ensures consistent messaging while leveraging each channel's unique strengths for maximum reach and engagement.
        </p>
        </div>

    </div>
    </section>

    {/* Section 17: Embrace Innovation */}
    <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-orange-500/70">
    <div className="max-w-7xl mx-auto">
        
        {/* Main Heading */}
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8">
        Embrace Innovation and Data-Driven Marketing to Win 
        </h2>

        {/* Top Description with Orange Left Border */}
        <div className="border-l-4 border-orange-100 pl-6 mb-12">
        <p className="text-black text-lg leading-relaxed">
            Digital marketing evolves faster than ever—adapt or fall behind. The brands that thrive are those that embrace change, leverage technology, and never stop learning.
        </p>
        </div>

        {/* Three Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
        
        {/* Card 1 - Leverage Cutting-Edge Technology */}
        <div className="bg-orange-300 rounded-2xl p-8 space-y-4">
            <h3 className="text-2xl font-bold text-black">
            Leverage Cutting-Edge Technology
            </h3>
            <p className="text-black text-base leading-relaxed">
            Harness AI, machine learning, and advanced personalization to create customer experiences that outpace competitors and exceed expectations.
            </p>
        </div>

        {/* Card 2 - Integrate Measurement Frameworks */}
        <div className="bg-orange-300 rounded-2xl p-8 space-y-4">
            <h3 className="text-2xl font-bold text-black">
            Integrate Measurement Frameworks
            </h3>
            <p className="text-black text-base leading-relaxed">
            Implement sophisticated attribution and marketing mix modeling to understand true ROI and optimize resource allocation continuously.
            </p>
        </div>

        {/* Card 3 - Balance Creativity and Data */}
        <div className="bg-orange-300 rounded-2xl p-8 space-y-4">
            <h3 className="text-2xl font-bold text-black">
            Balance Creativity and Data
            </h3>
            <p className="text-black text-base leading-relaxed">
            Build strategies that harmonize creative storytelling with analytical rigor, connecting with customers authentically while driving measurable results.
            </p>
        </div>

        </div>

        {/* Bottom Description */}
        <div className="mb-8">
        <p className="text-black text-lg leading-relaxed">
            Start today: develop a comprehensive strategy that balances innovative technology, authentic customer connection, and data-driven decision-making for lasting competitive advantage and sustainable business success in the digital age.
        </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap gap-6">
        <button className="px-8 py-4 bg-white text-orange-500 rounded-lg font-medium text-lg hover:bg-orange-500 hover:text-white transition border-2 border-neutral-800 text-neutral-800 rounded-lg">
            Start Your Strategy Now
        </button>
        <button className="px-8 py-4 bg-transparent border-2 border-neutral-800 text-neutral-800 rounded-lg font-medium text-lg hover:bg-white hover:text-black transition">
            Explore Resources
        </button>
        </div>

    </div>
    </section>
    </div>
  );
}

export default DigitalMarketing;